// Author Lin
// Date 2021-08-21 10:29:03

class SithMesInventoryPo {
        constructor({
                id = null,
                proWbsNo = '',
                proNo = '',
                proName = '',
                purNo = '',
                purBg = '',
                vendorNo = '',
                vendorEngName = '',
                vendorChnName = '',
                poCrtDate = '',
                requiredArrivalDate = '',
                actualArrivalDate = '',
                storageArea = '',
                specifications = '',
                confirmer = '',
                status = '',
                plant = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.proWbsNo = proWbsNo;
            this.proNo = proNo;
            this.proName = proName;
            this.purNo = purNo;
            this.purBg = purBg;
            this.vendorNo = vendorNo;
            this.vendorEngName = vendorEngName;
            this.vendorChnName = vendorChnName;
            this.poCrtDate = poCrtDate;
            this.requiredArrivalDate = requiredArrivalDate;
            this.actualArrivalDate = actualArrivalDate;
            this.storageArea = storageArea;
            this.specifications = specifications;
            this.confirmer = confirmer;
            this.status = status;
            this.plant = plant;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesInventoryPo();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'proWbsNo',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.proWbsNo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'proNo',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.proNo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'proName',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.proName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'purNo',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.purNo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'purBg',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.purBg',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vendorNo',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.vendorNo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vendorEngName',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.vendorEngName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vendorChnName',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.vendorChnName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'poCrtDate',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.poCrtDate',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'requiredArrivalDate',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.requiredArrivalDate',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'actualArrivalDate',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.actualArrivalDate',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'storageArea',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.storageArea',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'specifications',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.specifications',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'confirmer',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.confirmer',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'status',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.status',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'plant',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.plant',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryPo.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : "",
            idListFilter : "",
            proWbsNoFilter : "",
            proNoFilter : "",
            proNameFilter : "",
            purNoFilter : "",
            purBgFilter : "",
            vendorNoFilter : "",
            vendorEngNameFilter : "",
            vendorChnNameFilter : "",
            poCrtDateRteFilter : "",
            poCrtDateLteFilter : "",
            requiredArrivalDateRteFilter : "",
            requiredArrivalDateLteFilter : "",
            actualArrivalDateRteFilter : "",
            actualArrivalDateLteFilter : "",
            storageAreaFilter : "",
            specificationsFilter : "",
            confirmerFilter : "",
            statusFilter : "",
            plantFilter : ""
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'proWbsNoFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.proWbsNo',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'proNoFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.proNo',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'proNameFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.proName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'purNoFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.purNo',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'purBgFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.purBg',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vendorNoFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.vendorNo',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vendorEngNameFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.vendorEngName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vendorChnNameFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.vendorChnName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'poCrtDateRteFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.poCrtDateRte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'poCrtDateLteFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.poCrtDateLte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'requiredArrivalDateRteFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.requiredArrivalDateRte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'requiredArrivalDateLteFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.requiredArrivalDateLte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'actualArrivalDateRteFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.actualArrivalDateRte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'actualArrivalDateLteFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.actualArrivalDateLte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'storageAreaFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.storageArea',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'specificationsFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.specifications',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'confirmerFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.confirmer',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'statusFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.status',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'plantFilter',
                label: 'label.sith.inventory.sithMesInventoryPo.filter.plant',
                disabled: false,
                form: {
                type: 'input'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'proWbsNo',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.proWbsNo',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'proNo',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.proNo',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'proName',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.proName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'purNo',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.purNo',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'purBg',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.purBg',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vendorNo',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.vendorNo',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vendorEngName',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.vendorEngName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vendorChnName',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.vendorChnName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'poCrtDate',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.poCrtDate',
                sortable: true,
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'requiredArrivalDate',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.requiredArrivalDate',
                sortable: true,
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'actualArrivalDate',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.actualArrivalDate',
                sortable: true,
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'storageArea',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.storageArea',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'specifications',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.specifications',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'confirmer',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.confirmer',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'status',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.status',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'plant',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.plant',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryPo.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {SithMesInventoryPo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        